import { ClientComponentLogger } from '../../client-component-logger';
import { EventTracking } from './event-tracking';
import { TrackingDataExtractor } from './tracking-data-extractor';
import { TrackingHtmlConditionChecker } from './tracking-html-condition-checker';
import { TrackingComponent } from './tracking.component';
import { VariationDataEnhancer } from './variation-data-enhancer';
import { VariationIdEnhancer } from './variation-id-enhancer';
import { ViewTracking } from './view-tracking';
import { VisibilityTracking } from './visibility-tracking';

export const viewTrackingFactory = () => {
    const logger = new ClientComponentLogger('tracking');
    const trackingDataExtractor = new TrackingDataExtractor(logger);
    const trackingConditionChecker = new TrackingHtmlConditionChecker();
    const variationIdEnhancer = new VariationIdEnhancer();
    const variationDataEnhancer = new VariationDataEnhancer();

    const eventTracking = new EventTracking(trackingDataExtractor, variationIdEnhancer, variationDataEnhancer);
    const viewTracking = new ViewTracking(trackingDataExtractor, trackingConditionChecker);
    const visibilityTracking = new VisibilityTracking();

    return new TrackingComponent(eventTracking, viewTracking, visibilityTracking);
};
